import { Form, Formik } from "formik";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Card, Col, Input, Row } from "reactstrap";
import SignContext from "../../contextAPI/Context/SignContext";
import { useContext } from "react";
import * as Yup from "yup";
import { useFormSubmit } from "../../hooks/useFormSubmit";

const OtherDetails = (props) => {
  const [form, setform] = useState({
    permanatOrTemporary: "",
    periodOfTemporaryUnfit: "",
    department: "",
    exposureTo: "",
    natureOfTests: "",
    dateOFPosting: "",
    dateOfLeaving: "",
    reasons: "",
    signs: "",
    dateOfDeclaringUnfit: "",
    dateOfissuingFitness: "",
  });

  const { setForm32, GetSpecificForm32, editForm32 } = useContext(SignContext);

  // Debounce hook for form submissions
  const { handleSubmit: debouncedSubmit } = useFormSubmit(500);

  const handleSubmitData = async (values) => {
    const data = {
      ...props,
      chackupNameId: props.chackupNameId,
      checkupTypeId: props.checkupTypeId,
      ...values
    };

    try {
      const response = await setForm32(data);

      // Handle multiple response formats:
      // New format: { success: true, data: {...}, message: "..." }
      // Old format: { message: "..." }
      // Axios response: response.data contains the actual JSON
      const isSuccess = response?.success || 
                       response?.data?.success || 
                       (response?.message && !response?.error) ||
                       (response?.data?.message && !response?.data?.error);
      
      if (isSuccess) {
        toast.success("Other medical details (Form-32) saved successfully!");
        
        // Extract the Form32 ID from various possible locations
        const form32Id = response?.data?._id || 
                        response?._id || 
                        response?.data?.data?._id;
        
        if (props.onSuccess && form32Id) {
          props.onSuccess(form32Id);
        } else if (props.onSuccess) {
          // For backwards compatibility, call onSuccess even without ID
          props.onSuccess(true);
        }
      } else {
        // Handle case where response doesn't indicate success
        const errorMessage = response?.error || 
                           response?.data?.error || 
                           response?.message || 
                           response?.data?.message || 
                           "Failed to save Other medical details";
        toast.error(errorMessage);
      }
    } catch (error) {

      const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to save Other medical details";
      toast.error(errorMessage);
      throw error; // Re-throw to ensure proper error propagation
    }
  };

  const gettingid = async () => {
    if (props.form32id !== null) {
      const res = await GetSpecificForm32(props.form32id);

      setform(res.data);
    }
  };
  useEffect(() => {
    gettingid();
  }, [props.form32id]);
  const validationSchema = Yup.object().shape({
    permanatOrTemporary: Yup.string(),
    periodOfTemporaryUnfit: Yup.string(),
    department: Yup.string(),
    exposureTo: Yup.string(),
    natureOfTests: Yup.string(),
    dateOFPosting: Yup.date().nullable(),
    dateOfLeaving: Yup.date().nullable(),
    reasons: Yup.string(),
    signs: Yup.string(),
    dateOfDeclaringUnfit: Yup.date().nullable(),
    dateOfissuingFitness: Yup.date().nullable(),
  });

  return (
    <>
      {props.form32id !== null ? (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                form,
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  const data = {
                    ...props,
                    ...form,
                    chackupNameId: props.chackupNameId,
                    checkupTypeId: props.checkupTypeId,
                  };

                  try {
                    const res = await editForm32(props.form32id, data);
                    if (res && (res.data || res.success)) {
                      toast.success("Other medical details (Form-32) updated successfully!");
                      if (props.onSuccess) {
                        props.onSuccess(props.form32id);
                      }
                    }
                  } catch (error) {

                    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to update Other medical details";
                    toast.error(errorMessage);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Card>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className="align-items-center g-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Permanent / Temporary
                              </label>
                              <div className="mb-3">
                                <select
                                  className="form-select"
                                  name="permanatOrTemporary"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      permanatOrTemporary: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.permanatOrTemporary !== null &&
                                        form.permanatOrTemporary !== ""
                                        ? form.permanatOrTemporary
                                        : ""
                                      : ""
                                  }
                                >
                                  <option>--select--</option>
                                  <option value="permanent">Permanent</option>

                                  <option value="temporary">Temporary</option>
                                </select>
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Period of temporary unfit
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="period of temporary unfit"
                                  name="periodOfTemporaryUnfit"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      periodOfTemporaryUnfit: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.periodOfTemporaryUnfit !== null &&
                                        form.periodOfTemporaryUnfit !== ""
                                        ? form.periodOfTemporaryUnfit
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Department
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="department"
                                  name="department"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      department: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.department !== null &&
                                        form.department !== ""
                                        ? form.department
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Exposure to
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="exposureTo"
                                  name="exposureTo"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      exposureTo: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.exposureTo !== null &&
                                        form.exposureTo !== ""
                                        ? form.exposureTo
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-center g-3 mt-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date of Posting
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="DD/MM/YYYY"
                                  name="dateOFPosting"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      dateOFPosting: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.dateOFPosting !== null &&
                                        form.dateOFPosting !== ""
                                        ? form.dateOFPosting?.slice(0, 10)
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date of Leaving/Transfer
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="period of temporary unfit"
                                  name="dateOfLeaving"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      dateOfLeaving: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.dateOfLeaving !== null &&
                                        form.dateOfLeaving !== ""
                                        ? form.dateOfLeaving?.slice(0, 10)
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={4} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Reasons for Discharge leave or transfer
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="reasons for discharge"
                                  name="reasons"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      reasons: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.reasons !== null &&
                                        form.reasons !== ""
                                        ? form.reasons

                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Signs and Symptoms
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="signs&sympton"
                                  name="signs"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      signs: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.signs !== null && form.signs !== ""
                                        ? form.signs

                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Nature of Tests
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="nature of tests"
                                  name="natureOfTests"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      natureOfTests: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.natureOfTests !== null &&
                                        form.natureOfTests !== ""
                                        ? form.natureOfTests

                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-center g-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date for declaring unfit
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="DD/MM/YYYY"
                                  name="dateOfDeclaringUnfit"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      dateOfDeclaringUnfit: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.dateOfDeclaringUnfit !== null &&
                                        form.dateOfDeclaringUnfit !== ""
                                        ? form.dateOfDeclaringUnfit?.slice(
                                          0,
                                          10
                                        )
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date of issuing fitness
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="period of temporary unfit"
                                  name="dateOfissuingFitness"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      dateOfissuingFitness: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form
                                      ? form.dateOfissuingFitness !== null &&
                                        form.dateOfissuingFitness !== ""
                                        ? form.dateOfissuingFitness?.slice(
                                          0,
                                          10
                                        )
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="text-end mb-3 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Updating...
                          </>
                        ) : (
                          'Update'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                permanatOrTemporary: "",
                periodOfTemporaryUnfit: "",
                department: "",
                exposureTo: "",
                natureOfTests: "",
                dateOFPosting: "",
                dateOfLeaving: "",
                reasons: "",
                signs: "",
                dateOfDeclaringUnfit: "",
                dateOfissuingFitness: "",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {

                  try {
                    await handleSubmitData(values);
                  } catch (error) {

                    // Error toast is already handled in handleSubmitData, but ensure it's shown
                    const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || "Failed to save Other medical details";
                    toast.error(errorMessage);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Card>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className="align-items-center g-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Permanent / Temporary
                              </label>
                              <div className="mb-3">
                                <select
                                  className="form-select"
                                  name="permanatOrTemporary"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.permanatOrTemporary}
                                >
                                  <option>--select--</option>
                                  <option value="permanent">permanent</option>

                                  <option value="temporary">temporary</option>
                                </select>
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Period of temporary unfit
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="period of temporary unfit"
                                  name="periodOfTemporaryUnfit"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.periodOfTemporaryUnfit}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Department
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="department"
                                  name="department"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.department}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Exposure to
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="exposureTo"
                                  name="exposureTo"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.exposureTo}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3"></Row>
                        <Row className="align-items-center g-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date of Posting
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="DD/MM/YYYY"
                                  name="dateOFPosting"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.dateOFPosting}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date of Leaving/Transfer
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="period of temporary unfit"
                                  name="dateOfLeaving"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.dateOfLeaving}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={4} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Reasons for Discharge leave or transfer
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="reasons for discharge"
                                  name="reasons"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.reasons}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Signs and Symptoms
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="signs&sympton"
                                  name="signs"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.signs}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Nature of Tests
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="nature of tests"
                                  name="natureOfTests"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.natureOfTests}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-center g-3">
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date for declaring unfit
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="DD/MM/YYYY"
                                  name="dateOfDeclaringUnfit"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.dateOfDeclaringUnfit}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={4} md={6}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Date of issuing fitness
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="period of temporary unfit"
                                  name="dateOfissuingFitness"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.dateOfissuingFitness}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="text-end mb-3 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Submitting...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      )}
    </>
  );
};

export default OtherDetails;
